<template>
  <div class="modal fade !p-0" id="uniqueConfirmDialogModal" ref="confirmModal" tabindex="-1" aria-labelledby="confirmDialogModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered tablet:w-[450px]">
      <div class="modal-content !rounded-[10px] border-0 shadow-lg font-poppins">
        <div class="modal-body !p-[10px]">
          <div class="relative h-[80px] bg-customBlue-100 rounded-[10px]">
            <button type="button" @click="hide"
              class="absolute top-3 right-4 z-50 focus:!outline-none focus:!shadow-none bg-transparent border-0"
              aria-label="Close">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon" class="w-[30px] h-[30px]">
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <div class="relative flex justify-between items-center w-full z-10 ps-6 !pe-12 border-0">
                <h6 id="confirmDialogModalTitle" class="m-0 text-[20px] font-poppins font-semibold text-white tracking-wider">
                  {{ title }}
                </h6>
              </div>
            </div>
          </div>
          <div class="p-[20px] min-h-[150px] flex flex-col items-center justify-center">
            <div v-if="image != null"
              class="mb-4 p-3 w-[80px] h-[80px] rounded-full mx-auto shadow-[0px_0px_10px_-1px_#ccc]">
              <img :src="require(`@/assets/images/${image}`)" class="w-full h-full">
            </div>
            <p v-if="message.length <= 0" class="mb-[5px] font-poppins text-center text-[18px] text-[#333333]">
              {{ text }}
            </p>
            <p v-else v-html="message" class="mb-[5px] font-poppins text-center text-[18px] text-[#333333]">
            </p>
            <div class="mt-[20px] flex flex-row justify-center gap-3">
              <button @click="confirm"
                class="w-auto px-6 py-2 CustomYellowBtn rounded-full text-[16px] font-normal ">
                {{ buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/plugins/EventBus";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from 'bootstrap';

export default {
  props: ['confirmButtonText'],

  data() {
    return {
      modal: null,
      title: "",
      text: "",
      image: null,
      onConfirm: {},
      buttonText: 'Continue',
      isShowConfirmText: false,
      message: '' 
    };
  },

  mounted() {
    EventBus.on("confirmDialogShow", (params) => {
      this.show(params);
    });
  },

  methods: {
    hide() {
      if (this.modal) {
        this.modal.hide();
      }
      enableScroll();
    },
    confirm() {
      if (typeof this.onConfirm === "function") {
        this.onConfirm();
      }
      this.hide();
    },
    show(params) {
      this.title = params.title;
      this.text = params.text ?? "";
      this.image = params.image;
      this.isShowConfirmText = params.isShowConfirmText
      this.onConfirm = params.onConfirm;
      this.message = params.message ?? ''
      this.buttonText = params.buttonText ?? 'Continue'

      if (this.isShowConfirmText) {
        this.buttonText = "Confirm"
      }

      this.$nextTick(() => {
        const el = this.$refs.confirmModal;
        if (el) {
          if (!this.modal) {
            this.modal = Modal.getOrCreateInstance(el);
          }
          if (this.modal) {
            this.modal.show();
            disableScroll();
          }
        }
      });
    },
  },
};
</script>